import React from "react";

function SvgIcMapPoi062(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M25.5 22a.5.5 0 01.286.909c-.005.004-.01.006-.013.01A16.937 16.937 0 0116 26c-3.657 0-6.995-1.14-9.773-3.081-.003-.004-.008-.006-.013-.01A.5.5 0 016.5 22h19zM16 4l8.91 15.216.019.031a.5.5 0 01-.339.745L24.5 20H17c-.512 0-.936-.386-.994-.883L16 19V4zm-1.992 4v11a1 1 0 01-.884.993l-.116.007H7.5a.5.5 0 01-.467-.674l.037-.077.02-.036L14.009 8z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi062;
